import type { Resident } from '@/types';

import styles from './ArtCard.module.css';

export type CardVariant = 'a' | 'b' | 'c';
import ArtCardFrequency from './ArtCardFrequency';
import ArtCardIndex from './ArtCardIndex';
import ArtCardStrip from './ArtCardStrip';

interface ArtCardProps {
  artist: Resident;
  index: number;
  variant: CardVariant;
}

export function ArtCard({ artist, index, variant }: ArtCardProps) {
  if (variant === 'a') return <ArtCardStrip artist={artist} index={index} />;
  if (variant === 'b') return <ArtCardIndex artist={artist} index={index} />;
  return <ArtCardFrequency artist={artist} index={index} />;
}

interface ArtCardGridProps {
  artists: Resident[];
  variant: CardVariant;
}

export function ArtCardGrid({ artists, variant }: ArtCardGridProps) {
  return (
    <div className={styles.root} data-variant={variant}>
      {artists.map((a, i) => (
        <ArtCard key={a.slug} artist={a} index={i} variant={variant} />
      ))}
    </div>
  );
}

export default ArtCard;
